// The one write the portal makes: complete_work_order (packages/commands/src/portal.ts).
// accept / decline / set_out / progress / completion / issue are all the same
// command with a different `kind`. The portal never writes installations.
import {captureSession} from "./session-scope";
import type { ProposalResult } from "@artemis-group/aiw-contracts";
import { api, client } from "./api";
import type { Key, Vars } from "../i18n";

export type ReportKind = "accept" | "decline" | "set_out" | "progress" | "completion" | "issue";

export interface ReportInput {
  job_ref: string;
  installation_id: string | null;
  party_id: string;
  day_id?: string;
  kind: ReportKind;
  notes?: string;
  photos?: string[];
  photo_receipts?:string[];
  checklist?: Record<string, boolean>;
  /** part of the idempotency key: the day index for a completion, the case id for an offer */
  scope?: string;
}

const key = (r: ReportInput) => `wo:${r.job_ref}:${r.kind}:${r.scope ?? ""}:${crypto.randomUUID ? crypto.randomUUID() : Date.now()}`;

export function useFileReport(){const assertCurrent=captureSession();return (r:ReportInput)=>{assertCurrent();return fileReport(r);};}

async function fileReport(r: ReportInput): Promise<ProposalResult> {
  return api.propose(client, {
    command: "complete_work_order",
    args: { job_ref: r.job_ref, installation_id: r.installation_id, party_id: r.party_id, day_id:r.day_id, kind: r.kind, notes: r.notes ?? "", photos: r.photos ?? [], photo_receipts:r.photo_receipts??[], checklist: r.checklist ?? {} },
    idempotency_key: key(r),
  });
}

/** The backbone's answer in the installer's words, never the process. */
export function answerWords(r: ProposalResult | "failed"): { key: Key; vars?: Vars; tone: "ok" | "wait" | "bad" } {
  if (r === "failed") return { key: "ans_failed", tone: "bad" };
  switch (r.status) {
    case "executed": return { key: "ans_executed", tone: "ok" };
    case "pending": return { key: "ans_pending", tone: "wait" };
    default: return { key: "ans_denied", vars: { reason: r.reason }, tone: "bad" };
  }
}
